import { Box, Button, Stack } from '@mui/material';
import DataConfirmation from 'components/shared/data_confirmation';
import { formatDate } from 'utils/format_date';
import useStep2 from './use_step2';

type AnswersType = {
  question1: string | null;
  question2: string | null;
};

interface Step2Props {
  onNext: (answers: AnswersType) => void;
  onPrev?: () => void;
}

const Step2: React.FC<Step2Props> = ({ onNext, onPrev }) => {
  const { formData, handleSave } = useStep2();

  return (
    <Stack marginX='4rem' spacing='2rem'>
      <DataConfirmation
        title='Dados do Termo de Adesão'
        data={[
          {
            label: 'Prefeitura',
            value: formData?.dadosTermosAdesao?.prefeituraNome,
          },
          {
            label: 'Data Assinatura',
            value: formatDate(formData?.dadosTermosAdesao?.dataAssinatura),
          },
          {
            label: 'Status',
            value: formData?.dadosTermosAdesao?.status ? 'Ativo' : 'Inativo',
          },
        ]}
      />
      <DataConfirmation
        title='Anexar Termo de Adesão'
        atas={[
          {
            titlePDF: 'Arquivo Enviado',
            label: formData?.anexoArquivo?.name,
            fileName: `${formData?.anexoArquivo?.type}`,
            fileSize: `${formData?.anexoArquivo?.size} KB`,
            base64: formData?.anexoArquivo?.base64,
            onView: () => console.log('Visualizar documento'),
          },
        ]}
      />

      {/* Botões */}
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        gap={2}
        marginTop='20px'
      >
        <Button
          variant='text'
          onClick={onPrev}
          sx={{
            color: '#1976D2',
            fontWeight: 'bold',
            textTransform: 'uppercase',
          }}
        >
          Voltar
        </Button>

        <Button
          variant='contained'
          onClick={handleSave}
          sx={{
            backgroundColor: '#0048B6',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            '&:hover': {
              backgroundColor: '#003399',
            },
          }}
        >
          Confirmar e salvar
        </Button>
      </Box>
    </Stack>
  );
};

export default Step2;
